function isValidHttpUrl(string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  if (!/^https?:$/.test(url.protocol)) {
    return false;
  }

  return url;
}

export default isValidHttpUrl;
